import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Lenis from "@studio-freight/lenis";

// Pages
import HomePage from "@/pages/HomePage";
import SoundExperiencesPage from "@/pages/SoundExperiencesPage";
import TreatmentsPage from "@/pages/TreatmentsPage";
import SwayWithSoundPage from "@/pages/SwayWithSoundPage";
import MembershipPage from "@/pages/MembershipPage";
import BookingPage from "@/pages/BookingPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import GiftVouchersPage from "@/pages/GiftVouchersPage";
import GiftVoucherSuccessPage from "@/pages/GiftVoucherSuccessPage";
import AdminPage from "@/pages/AdminPage";
import ShopPage from "@/pages/ShopPage";
import MensTreatmentsPage from "@/pages/MensTreatmentsPage";
import CancellationPolicyPage from "@/pages/CancellationPolicyPage";
import TermsPage from "@/pages/TermsPage";

// Components
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

// Global Lenis instance reference
let lenisInstance = null;

// Scroll to top on route change - works with Lenis
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    if (lenisInstance) {
      lenisInstance.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  
  return null;
}

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
    });

    lenisRef.current = lenis;
    lenisInstance = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <div className="noise-overlay" aria-hidden="true" />
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/sound-experiences" element={<SoundExperiencesPage />} />
            <Route path="/treatments" element={<TreatmentsPage />} />
            <Route path="/sound-healing" element={<TreatmentsPage />} />
            <Route path="/sway-with-sound" element={<SwayWithSoundPage />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/booking/success" element={<BookingSuccessPage />} />
            <Route path="/gift-vouchers" element={<GiftVouchersPage />} />
            <Route path="/gift-vouchers/success" element={<GiftVoucherSuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/mens-treatments" element={<MensTreatmentsPage />} />
            <Route path="/cancellation-policy" element={<CancellationPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
